import { render, staticRenderFns } from "./gauge-semicircle-chart.component.vue?vue&type=template&id=8191d836&scoped=true"
import script from "./gauge-semicircle-chart.component.vue?vue&type=script&lang=ts"
export * from "./gauge-semicircle-chart.component.vue?vue&type=script&lang=ts"
import style0 from "./gauge-semicircle-chart.component.vue?vue&type=style&index=0&id=8191d836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8191d836",
  null
  
)

export default component.exports